<!-- Client Select -->
<app-client-select
  [clients]="clients"
  [selectedClientID]="selectedClientId"
  (clientChange)="onClientChange($event)"
></app-client-select>

<!-- Years MultiSelect -->
<ejs-multiselect
  [dataSource]="years"
  [fields]="yearFields"
  [placeholder]="'Year...'"
  [value]="selectedYearIds"
  mode="CheckBox"
  [showSelectAll]="true"
  selectAllText="Select All"
  (valueChange)="onYearChange($event)"
></ejs-multiselect>

<!-- Programs MultiSelect -->
<ejs-multiselect
  [dataSource]="programs"
  [fields]="programFields"
  [placeholder]="'Program...'"
  [value]="selectedProgramIds"
  mode="CheckBox"
  [showSelectAll]="true"
  selectAllText="Select All"
  (valueChange)="onProgramChange($event)"
></ejs-multiselect>
